import { Scene } from '@babylonjs/core/scene';
import { DefaultRenderingPipeline } from '@babylonjs/core/PostProcesses/RenderPipeline/Pipelines/defaultRenderingPipeline';
import type { Camera } from '@babylonjs/core/Cameras/camera';

export function setupPostProcessing(scene: Scene, camera: Camera): DefaultRenderingPipeline {
  const pipeline = new DefaultRenderingPipeline('default', true, scene, [camera]);

  // ── Bloom — subtle glow on the white ball and tracer ──
  pipeline.bloomEnabled = true;
  pipeline.bloomThreshold = 0.6;
  pipeline.bloomWeight = 0.3;
  pipeline.bloomKernel = 64;
  pipeline.bloomScale = 0.5;

  // ── Anti-aliasing ──
  pipeline.fxaaEnabled = true;
  pipeline.samples = 4;

  // ── Tone mapping — slightly darker, contrasty ──
  pipeline.imageProcessingEnabled = true;
  pipeline.imageProcessing.exposure = 1.15;
  pipeline.imageProcessing.contrast = 1.05;
  pipeline.imageProcessing.toneMappingEnabled = true;
  pipeline.imageProcessing.toneMappingType = 1; // ACES

  // ── Sharpen ──
  pipeline.sharpenEnabled = true;
  pipeline.sharpen.edgeAmount = 0.2;

  // ── Vignette — dark edges for cinematic feel ──
  pipeline.imageProcessing.vignetteEnabled = true;
  pipeline.imageProcessing.vignetteWeight = 1.0;
  pipeline.imageProcessing.vignetteStretch = 0;
  pipeline.imageProcessing.vignetteCameraFov = 0.5;

  return pipeline;
}
